import { render, staticRenderFns } from "./LastUpdate.vue?vue&type=template&id=31d2ef6e&scoped=true"
import script from "./LastUpdate.vue?vue&type=script&lang=js"
export * from "./LastUpdate.vue?vue&type=script&lang=js"
import style0 from "./LastUpdate.vue?vue&type=style&index=0&id=31d2ef6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2ef6e",
  null
  
)

export default component.exports